import React from 'react';
import PropTypes from 'prop-types';
//styles
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './TripsContainer.css';
// Component
import Trips from '../../components/Trips';

const TripsContainer = ({ userType, type }) => {
  return (
    <Trips userType={userType} type={type} />
  );
}
TripsContainer.propTypes = {
  userType: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default withStyles(s)(TripsContainer);